<template>
  <div>
    <v-dialog persistent v-model="mostrarAbonoEnvio" max-width="700px">
      <v-card>
        <v-card-title>Abono envio</v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  autofocus
                  outlined
                  label="Cantidad a abonar"
                  v-model="objetoAbono.Abono"
                >
                </v-text-field>
                
              </v-col>
              <v-col cols="12">
                <v-select
                  v-model="metodoPago"
                  :items="['Efectivo', 'Transferencia', 'Deposito']"
                  label="Método de pago"
                  outlined
                ></v-select>
                <span style="font-weight:bold;">Saldo envio elegido: {{ formateaMoneda(saldoEnvio) }}</span>
                <div v-if="cambioRegresado != ''">
                  <span>
                    Cambio cliente:
                  </span>
                  <span style="font-weight:bold;"> {{ formateaMoneda(cambioRegresado) }} </span>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" @click="$emit('cerrar-modal-abono-envio')" text
            >Cancelar</v-btn
          >
          <v-btn color="blue darken-1" @click="realizarAbonoEnvio()" text>Realizar abono</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { FormatoMoneda, FormatoGuia } from "@/Utils/Utils";
import { mapState, mapActions } from "vuex";
import { required } from "vuelidate/lib/validators";

export default {
  components: {},
  props: {
    mostrarAbonoEnvio: Boolean,
    idAbono: Number,
    saldoEnvio: Number
  },
  async mounted() {
    this.objetoAbono.IdEnvio = this.idAbono;
  },
  methods: {
    ...mapActions("abonosEnvios", ["insertAbono"]),
    formateaMoneda(moneda) {
      return FormatoMoneda.format(moneda);
    },
    async realizarAbonoEnvio() {
      this.objetoAbono.idSucursal = this.logedInUserInfo.sucursal;
      this.objetoAbono.tipo_pago = this.metodoPago;
      const res = await this.insertAbono(this.objetoAbono);
      if (res[0] == true) {
        this.$emit("muestraMensaje", "abonoCorrecto");
        
      } else if (res[1] == "envioprevpagado") {
        this.$emit("muestraMensaje", "envioprevpagado");
      }
    }
  },
  computed: {
    ...mapState({
      logedInUserInfo: state => state.sesion.logedInUserInfo
    }),
    cambioRegresado() {
      let cambio = this.saldoEnvio - this.objetoAbono.Abono;
      if (cambio < 0) {
        let cadena = `${parseFloat(Math.abs(cambio).toFixed(2))}`;
        return cadena;
      } else {
        let cadena = "";
        return cadena;
      }
    }
  },
  data: () => ({
    metodoPago:"Efectivo",
    objetoAbono: {
      IdEnvio: 0,
      idSucursal: "2",
      Abono: ""
    }
  })
};
</script>
